import {
  FETCH_ORDER_TYPE_REQUEST,
  FETCH_ORDER_TYPE_SUCCESS,
  FETCH_ORDER_TYPE_FAILURE,
  ADD_ORDER_TYPE_REQUEST,
  ADD_ORDER_TYPE_SUCCESS,
  ADD_ORDER_TYPE_FAILURE,
  UPDATE_ORDER_TYPE_REQUEST,
  UPDATE_ORDER_TYPE_SUCCESS,
  UPDATE_ORDER_TYPE_FAILURE,
  DELETE_ORDER_TYPE_REQUEST,
  DELETE_ORDER_TYPE_SUCCESS,
  DELETE_ORDER_TYPE_FAILURE,
  ORDER_TYPE_FORM_ERROR,
  ORDER_TYPE_FORM_SUCCESS,
  SET_ORDER_TYPE_EDIT,
  CLEAR_ORDER_TYPE_EDIT,
} from '../../../types/masters/orderType/orderTypeTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingOrderType: null,
};

const orderTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ORDER_TYPE_REQUEST:
    case ADD_ORDER_TYPE_REQUEST:
    case UPDATE_ORDER_TYPE_REQUEST:
    case DELETE_ORDER_TYPE_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_ORDER_TYPE_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_ORDER_TYPE_SUCCESS:
    case UPDATE_ORDER_TYPE_SUCCESS:
    case DELETE_ORDER_TYPE_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_ORDER_TYPE_FAILURE:
    case ADD_ORDER_TYPE_FAILURE:
    case UPDATE_ORDER_TYPE_FAILURE:
    case DELETE_ORDER_TYPE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case ORDER_TYPE_FORM_ERROR:
      return {...state, loading:false, formError: action.payload};
      case ORDER_TYPE_FORM_SUCCESS:
        return {...state, loading:false, formSuccess: action.payload};
    case SET_ORDER_TYPE_EDIT:
      return { ...state, editingOrderType: action.payload };
    case CLEAR_ORDER_TYPE_EDIT:
      return { ...state, editingOrderType: null };
    default:
      return state;
  }
};

export default orderTypeReducer; 